export const baseurl = {
    url: process.env.REACT_APP_BASE_URL,
    token: process.env.REACT_APP_TOKEN,
    cloudinaryUploadPreset: "preset_dt6ammifo",
    cloudinaryCloudName: "dt6ammifo"
    // cloudinaryUploadPreset: process.env.REACT_APP_CLOUNDIANRY_UPLOAD_PRESET,
    // cloudinaryCloudName: process.env.REACT_APP_CLOUNDIANRY_NAME
}